import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="w-full px-4 md:px-6 py-12 md:py-14">
        <div className="max-w-6xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h4 className="font-heading text-lg font-semibold text-foreground-900 mb-3">朝桐光</h4>
            <p className="text-sm text-foreground-500 leading-relaxed">
              朝桐光官方粉丝资讯站，汇聚最新资讯、作品介绍、个人档案及粉丝社区讨论。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-900 mb-3">快速导航</h4>
            <div className="flex flex-col gap-2">
              <Link to="/category/news" className="text-sm text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer">最新资讯</Link>
              <Link to="/category/works" className="text-sm text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer">作品全集</Link>
              <Link to="/category/photos" className="text-sm text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer">写真图集</Link>
              <Link to="/category/community" className="text-sm text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer">粉丝社区</Link>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-900 mb-3">关于我们</h4>
            <div className="flex flex-col gap-2">
              <Link to="/about" className="text-sm text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer">品牌介绍</Link>
              <a href="#contact" className="text-sm text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer">联系我们</a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-900 mb-3">关注我们</h4>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200 text-foreground-600 hover:bg-primary-100 hover:text-primary-600 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200 text-foreground-600 hover:bg-primary-100 hover:text-primary-600 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200 text-foreground-600 hover:bg-primary-100 hover:text-primary-600 transition-colors cursor-pointer" aria-label="Twitter">
                <i className="ri-twitter-x-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200 text-foreground-600 hover:bg-primary-100 hover:text-primary-600 transition-colors cursor-pointer" aria-label="Instagram">
                <i className="ri-instagram-line text-lg"></i>
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-background-200/70">
        <div className="w-full px-4 md:px-6 py-4">
          <div className="max-w-6xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-2">
            <p className="text-xs text-foreground-400">
              &copy; {new Date().getFullYear()} 朝桐光官方粉丝资讯站. All rights reserved.
            </p>
            <p className="text-xs text-foreground-400">
              本站为非营利性粉丝资讯平台，所有内容仅供粉丝交流使用
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}